import DecisionTemplateSelector from './DecisionTemplateSelector';

interface ResponseToAuthorFieldProps {
  submissionId: string;
  decisionType: string;
  fieldName?: string;
  templateLabel?: string;
  templatePlaceholder?: string;
  subtypeSelected?: string;
}

const ResponseToAuthorField = ({
  submissionId,
  decisionType,
  fieldName = 'editorComment',
  templateLabel = 'Pre-filled Responses to Author',
  templatePlaceholder = 'Select a Response',
  subtypeSelected
}: ResponseToAuthorFieldProps) => {
  return (
    <DecisionTemplateSelector
      submissionId={submissionId}
      decisionType={decisionType}
      templateType="RESPONSE_TO_AUTHOR"
      targetFieldName={fieldName}
      label={templateLabel}
      placeholder={templatePlaceholder}
      subtypeSelected={subtypeSelected}
    />
  );
};

export default ResponseToAuthorField;
